export const languageOptions = [
  { value: "zh-hk", text: "中", description: "中文", locale: "zh-hk" },
  { value: "en-us", text: "Eng", description: "English", locale: "en-gb" },
];
